export enum ProductCoatingCompatibility {
    NotAssessed,
    Yes,
    YesWithRestriction,
    No,
}
